export const CONFIG_OBJ_ENUM = {
  ENABLE_MEMBER_GROUP: "enableMemberGroup",
  DISABLE_POINT_SPLIT: "disablePointSplit"
};
